import React from "react";

function PlayerFixtures(props) {
  const { fixtures } = props;

  const getTeamBadge = (teamName) => {
    if (!teamName) {
      return null;
    }

    try {
      return require(`../images/team_badges/${teamName}.svg`);
    } catch (e) {
      return null;
    }
  };

  if (!fixtures || fixtures.length === 0) {
    return null;
  }

  return (
    <React.Fragment>
      {fixtures.map((f, index) => (
        <span key={index} className="player-fixture">
          {getTeamBadge(f.Opponent) && (
            <img
              src={getTeamBadge(f.Opponent)}
              alt={f.Opponent}
              className="player-team-badge"
            />
          )}
          <span
            className={`player-fixture-venue player-fixture-difficulty-${f.Difficulty}`}
          >
            {f.Home ? "H" : "A"}
          </span>
        </span>
      ))}
    </React.Fragment>
  );
}

export default PlayerFixtures;
